import * as Yup from 'yup'

interface ValidatorOptions {
  isExpirationDateRequired: boolean
  /** A temporary license needs the name, address and expiry — the backend 400s without them. */
  isTemporaryDriverLicense: boolean
}

const requiredWhen = (isRequired: boolean, message: string) => {
  return isRequired ? Yup.string().trim().required(message) : Yup.string()
}

/**
 * Field-level shape only. Whether the form may be SUBMITTED is `resolveApproveBlockReason`,
 * which needs the step's metadata and document count and so cannot live in a Yup schema.
 */
export const buildContractorReviewValidator = ({
  isExpirationDateRequired,
  isTemporaryDriverLicense,
}: ValidatorOptions) => {
  return Yup.object({
    firstName: requiredWhen(isTemporaryDriverLicense, 'First name is required.'),
    lastName: requiredWhen(isTemporaryDriverLicense, 'Last name is required.'),
    documentId: Yup.string(),
    dateIssued: Yup.string(),
    effectiveAt: Yup.string(),
    expiresAt: requiredWhen(
      isExpirationDateRequired || isTemporaryDriverLicense,
      'Expiration date is required.',
    ),
    addressStreet1: requiredWhen(isTemporaryDriverLicense, 'Street 1 is required.'),
    addressStreet2: Yup.string(),
    addressCity: requiredWhen(isTemporaryDriverLicense, 'City is required.'),
    addressState: requiredWhen(isTemporaryDriverLicense, 'State is required.'),
    addressPostalCode: requiredWhen(isTemporaryDriverLicense, 'Postal code is required.'),
  })
}
